import { render } from "./form8.vue?vue&type=template&id=d991bb18"
import script from "./form8.vue?vue&type=script&lang=js"
export * from "./form8.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__